<h1>Albion Online Transport Calculator</h1>
@if (selectedItem && selectedItem.localizedName) {
  <h2>{{ selectedItem.localizedName }}</h2>
} @else {
  <h2><br /></h2>
}
<mat-tab-group ngSkipHydration>
  <mat-tab label="Item Selection">
    @if (shopCategories && items && !isLoading) {
      <div class="form-container">
        <app-item-selector
          class="form-container-inline"
          [shopCategories]="shopCategories"
          [items]="items"
          [showItemSelector]="true"
          [(selectedCategory)]="selectedCategory"
          [(selectedSubCategory)]="selectedSubCategory"
          [(selectedTier)]="selectedTier"
          [(selectedItem)]="selectedItem"
        >
        </app-item-selector>
        <mat-form-field class="form-item-small">
          <mat-label>Amount</mat-label>
          <input matInput [(ngModel)]="userSettingsService.getUserTransportConfig().amount" type="number" step="1" min="1" />
        </mat-form-field>
      </div>
    } @else {
      <mat-spinner></mat-spinner>
    }
  </mat-tab>
  <mat-tab label="Location/Market Info">
    <div class="form-container">
      <div class="flex-container-column form-item-medium">
        <mat-checkbox [(ngModel)]="userSettingsService.getUserTransportConfig().isPremium">Premium</mat-checkbox>
        <mat-label style="padding-left: 6px">Sales Taxes {{ userSettingsService.getUserTransportConfig().salesTax.value | percent: '1.2-2' }}</mat-label>
      </div>
      <button
        class="form-item-button"
        style="align-self: auto"
        mat-mini-fab
        (click)="refreshPrices()"
        [disabled]="(!(this.prices$ | async) && !(this.histories$ | async)) || disableRefresh"
        color="primary"
        aria-label="Clear All Button"
        matTooltip="Refresh Prices - ATTENTION! This will clear all manually entered prices!"
      >
        <mat-icon>refresh</mat-icon>
      </button>
      <mat-form-field class="form-item-medium" appearance="fill">
        <mat-label>Buy Location</mat-label>
        <mat-select [(value)]="userSettingsService.getUserTransportConfig().buyLocation" (selectionChange)="updateRealBuyPrice()">
          @for (location of locations; track location) {
            <mat-option [value]="location">
              {{ location.displayName }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="form-item-medium" appearance="fill">
        <mat-label>Buy From...</mat-label>
        <mat-select [(value)]="userSettingsService.getUserTransportConfig().buyPriceType" (selectionChange)="updateRealBuyPrice()">
          @for (type of priceTypes; track type) {
            <mat-option [value]="type">
              {{ type.friendlyName }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="form-item-medium" appearance="fill">
        <mat-label>Sell To...</mat-label>
        <mat-select [(value)]="userSettingsService.getUserTransportConfig().sellPriceType" (selectionChange)="updateRealSellPrice()">
          @for (type of priceTypes; track type) {
            <mat-option [value]="type">
              {{ type.friendlyName }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="form-item-medium">
        <mat-label>Number of Days for Average</mat-label>
        <input
          matInput
          [(ngModel)]="userSettingsService.getUserTransportConfig().averageNumberOfDays"
          type="number"
          step="1"
          min="3"
          max="30"
          (ngModelChange)="updateRealSellPrice()"
        />
      </mat-form-field>
      <mat-form-field class="form-item-medium" appearance="fill">
        <mat-label>Setup Fee</mat-label>
        <mat-select [(value)]="userSettingsService.getUserTransportConfig().setupFee">
          @for (fee of setupFees; track fee) {
            <mat-option [value]="fee">
              {{ fee.value | percent: '1.2-2' }}
            </mat-option>
          }
        </mat-select>
        <mat-hint>{{ userSettingsService.getUserTransportConfig().setupFee.name }}</mat-hint>
      </mat-form-field>
    </div>
  </mat-tab>
</mat-tab-group>
<button mat-fab extended color="primary" (click)="saveTransportConfiguration()" [disabled]="disableSaveConfig" style="margin: 5px 0px">
  <mat-icon>save</mat-icon>
  Save Transport Configuration
</button>
@if (selectedItem) {
  <div class="flex-container-column">
    <div class="text-divider">
      <span class="text">BUY</span>
      <mat-divider class="line"></mat-divider>
    </div>
    <div class="flex-container-row">
      <app-item-trade-card
        [itemName]="selectedItem.localizedName"
        [itemUniqueName]="selectedItem.uniqueName"
        [location]="userSettingsService.getUserTransportConfig().buyLocation"
        [itemAmount]="userSettingsService.getUserTransportConfig().amount"
        [totalWeight]="totalWeight"
        [tradeType]="{ type: 'buy' }"
        [(price)]="realBuyPrice"
        [totalPrice]="totalBuyPrice"
        [setupFee]="buySetupFee"
        [salesTax]="0"
        [averageAmount]="getAverage(userSettingsService.getUserTransportConfig().buyLocation).averageAmount ?? 0"
      >
        @if (histories && selectedItem) {
          <app-spark-line-chart
            class="width-100"
            [chosenPrice]="realBuyPrice"
            [histories]="histories"
            [item]="selectedItem"
            [location]="userSettingsService.getUserTransportConfig().buyLocation"
          />
        }
      </app-item-trade-card>
    </div>
    <div class="text-divider">
      <span class="text">SELL</span>
      <mat-divider class="line"></mat-divider>
    </div>
    <div class="flex-container-row">
      @for (location of locations; track location) {
        <app-item-trade-card
          [itemName]="selectedItem.localizedName"
          [itemUniqueName]="selectedItem.uniqueName"
          [location]="location"
          [itemAmount]="userSettingsService.getUserTransportConfig().amount"
          [totalWeight]="totalWeight"
          [tradeType]="{ type: 'sell' }"
          [price]="realSellPriceMap.get(location) ?? 0"
          [totalPrice]="getTotalSellPrice(location)"
          [setupFee]="getSellSetupFee(location)"
          [salesTax]="getSellSalesTaxes(location)"
          [averageAmount]="getAverage(location).averageAmount ?? 0"
          (priceChange)="setRealSellPrice(location, $event)"
          [finalResult]="getResult(location)"
          [finalResultPercentage]="getResultPercentage(location)"
        >
          @if (histories && selectedItem) {
            <app-spark-line-chart
              class="width-100"
              [chosenPrice]="realSellPriceMap.get(location) ?? 0"
              [histories]="histories"
              [item]="selectedItem"
              [location]="location"
            />
          }
        </app-item-trade-card>
      }
    </div>
  </div>
}
